import React from 'react';
import PropTypes from 'prop-types';

import RadioButtonSelected from "../RadioButtonSelected";
import RadioButtonNotSelected from "../RadioButtonNotSelected";

const RadioButton = ({
                       disabled, selected, wrapperStyle
                     }) => {
  return (
    <label style={wrapperStyle}>
      {selected ? <RadioButtonSelected/> : <RadioButtonNotSelected/>}
    </label>
  );
};

RadioButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  wrapperStyle: PropTypes.object,
};

RadioButton.defaultProps = {
  selected: false,
  wrapperStyle: {},
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/radio-button/index.jsx